import PageHero from "@/components/PageHero";
import { Reveal, PageShell } from "@/components/Reveal";

const STIMMEN = [
  {
    id: "petra",
    quote: "Jede Yogastunde mit Carmen ist eine Wohltat.",
    body: [
      "Mit ihrer ruhigen, einfühlsamen und herzlichen Art schafft sie eine Atmosphäre, in der man sofort ankommt und loslassen kann. Man fühlt sich gesehen und gut aufgehoben und nimmt jedes Mal neue Kraft und innere Ruhe mit nach Hause. Von mir mit ganz viel Herz eine klare Empfehlung!",
    ],
    name: "Petra",
  },
  {
    id: "entspannen",
    quote: "Ich konnte vollkommen entspannen.",
    body: [
      "Schon beim Ankommen habe ich mich sehr gut aufgehoben gefühlt. Mit ihrer achtsamen, einfühlsamen und gleichzeitig sehr professionellen Art hat Carmen einen Raum geschaffen, in dem ich vollkommen entspannen konnte.",
      "Ich kam mit starken Verspannungen im Rücken- und Schulterbereich und die Shiatsu-Behandlung war für mich ein ganz besonderes Erlebnis. Ich hätte am liebsten gar nicht mehr von der Liege aufstehen mögen.",
      "Meine erste Shiatsu-Erfahrung – und ganz sicher nicht meine letzte.",
    ],
  },
  {
    id: "geborgenheit",
    quote: "Deine Ruhe hat mir ein Gefühl von Geborgenheit vermittelt.",
    body: [
      "Ich fühlte mich so gut bei dir aufgehoben und konnte ganz tief entspannen. Nach der Behandlung fühlte ich mich erfrischt und wieder bei mir angekommen.",
      "Meine Rückenschmerzen hatten sich bereits nach der letzten Behandlung deutlich verbessert. Auf deine Art der Berührung kann ich mich vollkommen einlassen.",
    ],
  },
  {
    id: "mehr-als-entspannung",
    quote: "Shiatsu ist so viel mehr als nur Entspannung.",
    body: [
      "Shiatsu begleitet mich schon viele Jahre. Auch in sehr stressigen Zeiten bringt mich eine Shiatsu-Behandlung immer wieder zu mir zurück und regt sanft meine Selbstheilungskräfte an.",
    ],
  },
];

export default function Kundenstimmen() {
  return (
    <PageShell testid="kundenstimmen-page">
      <PageHero title="Kundenstimmen" testid="kundenstimmen-hero" />

      <section data-testid="kundenstimmen-liste" className="px-6 pb-28 md:px-12 md:pb-40">
        <div className="mx-auto max-w-5xl">
          {STIMMEN.map((s, i) => (
            <Reveal key={s.id} delay={0.05}>
              <blockquote
                data-testid={`kundenstimme-${s.id}`}
                className={`relative border-t border-anthrazit/15 py-14 last:border-b md:py-20 ${
                  i % 2 === 1 ? "md:ml-auto md:text-right" : ""
                } md:max-w-3xl`}
              >
                <span
                  aria-hidden="true"
                  className={`pointer-events-none absolute top-6 font-serif text-[7rem] leading-none text-sand/50 md:text-[9rem] ${
                    i % 2 === 1 ? "md:right-0 md:left-auto -left-4" : "-left-4"
                  }`}
                >
                  „
                </span>
                <h2 className="relative font-serif text-2xl italic leading-snug text-rot md:text-[2rem]">
                  „{s.quote}“
                </h2>
                <div className="relative mt-7 space-y-5">
                  {s.body.map((p, j) => (
                    <p
                      key={j}
                      className="text-base leading-loose text-anthrazit/80 md:text-lg"
                    >
                      {p}
                    </p>
                  ))}
                </div>
                {s.name && (
                  <footer className="relative mt-7 text-xs uppercase tracking-[0.35em] text-rot">
                    {s.name}
                  </footer>
                )}
              </blockquote>
            </Reveal>
          ))}
        </div>
      </section>
    </PageShell>
  );
}
